module.exports = __webpack_public_path__ + "img/rotterdam2.0e11da6b.jpg";